import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let PopoverComp;

class Popover extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: PopoverComp };  
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/popover-comp" */
            "../../../components/javascript/zcat-components/popover-comp"
        ).then(function(res) {
            PopoverComp = res.PopoverComp;
        }));

        
;
    }
}

export {Popover};

